var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big"},[_c('div',{staticClass:"div_html",staticStyle:{"font-size":"0"},domProps:{"innerHTML":_vm._s(_vm.userList.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }